import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'Secure & Encrypted',
      description: 'Your data is protected with bank-level security'
    },
    {
      icon: 'Lock',
      title: 'Privacy Protected',
      description: 'We never share your personal information'
    },
    {
      icon: 'CheckCircle',
      title: 'Verified Platform',
      description: 'Trusted by thousands of event organizers'
    }
  ];

  const securityBadges = [
    {
      name: 'SSL Secured',
      icon: 'Shield',
      color: 'text-green-600'
    },
    {
      name: 'GDPR Compliant',
      icon: 'FileCheck',
      color: 'text-blue-600'
    },
    {
      name: 'SOC 2 Certified',
      icon: 'Award',
      color: 'text-purple-600'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Trust Features */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-gray-900 text-center">
          Why Choose Tixful?
        </h3>
        <div className="space-y-4">
          {trustFeatures?.map((feature, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={16} className="text-blue-600" />
              </div>
              <div>
                <h4 className="text-sm font-medium text-gray-900">{feature?.title}</h4>
                <p className="text-xs text-gray-600 mt-1">{feature?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Security Badges */}
      <div className="border-t border-gray-200 pt-6">
        <h4 className="text-sm font-medium text-gray-900 text-center mb-4">
          Security & Compliance
        </h4>
        <div className="flex justify-center space-x-6">
          {securityBadges?.map((badge, index) => (
            <div key={index} className="flex flex-col items-center space-y-1">
              <Icon name={badge?.icon} size={20} className={badge?.color} />
              <span className="text-xs text-gray-600 text-center">{badge?.name}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Statistics */}
      <div className="bg-gray-50 rounded-lg p-4">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <div className="text-lg font-bold text-gray-900">50K+</div>
            <div className="text-xs text-gray-600">Active Users</div>
          </div>
          <div>
            <div className="text-lg font-bold text-gray-900">10K+</div>
            <div className="text-xs text-gray-600">Events Hosted</div>
          </div>
          <div>
            <div className="text-lg font-bold text-gray-900">99.9%</div>
            <div className="text-xs text-gray-600">Uptime</div>
          </div>
        </div>
      </div>
      {/* Contact Support */}
      <div className="text-center">
        <p className="text-xs text-gray-600 mb-2">Need help getting started?</p>
        <button className="text-xs text-blue-600 hover:text-blue-700 font-medium">
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default TrustSignals;